export default __webpack_public_path__ + "static/automobile-fancy-carousel-6312bb42b87a2117be09c19d8cd811b9.gif";